/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmPaymentApiResponse } from '../models/ConfirmPaymentApiResponse';
import type { CreateBookingApiResponse } from '../models/CreateBookingApiResponse';
import type { CreateBookingDto } from '../models/CreateBookingDto';
import type { CreateFollowupBookingDto } from '../models/CreateFollowupBookingDto';
import type { ExpertAvailabilityApiResponse } from '../models/ExpertAvailabilityApiResponse';
import type { ExpertPackagesApiResponse } from '../models/ExpertPackagesApiResponse';
import type { ExpertPricingApiResponse } from '../models/ExpertPricingApiResponse';
import type { ExpertServicesApiResponse } from '../models/ExpertServicesApiResponse';
import type { LocationsApiResponse } from '../models/LocationsApiResponse';
import type { PreviewBookingApiResponse } from '../models/PreviewBookingApiResponse';
import type { PreviewBookingDto } from '../models/PreviewBookingDto';
import type { ReportPaymentEventApiResponse } from '../models/ReportPaymentEventApiResponse';
import type { ReportPaymentEventDto } from '../models/ReportPaymentEventDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppBookingsService {
    /**
     * Preview booking price summary
     * @param requestBody
     * @returns PreviewBookingApiResponse Booking preview calculated
     * @throws ApiError
     */
    public static clientBookingsControllerPreviewBookingV1(
        requestBody: PreviewBookingDto,
    ): CancelablePromise<PreviewBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/bookings/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create a booking and initiate payment
     * @param requestBody
     * @returns CreateBookingApiResponse Booking created
     * @throws ApiError
     */
    public static clientBookingsControllerCreateBookingV1(
        requestBody: CreateBookingDto,
    ): CancelablePromise<CreateBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/bookings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `errorCode LATE_PAYMENT: retry of an expired booking whose payment went through; client must contact support`,
            },
        });
    }
    /**
     * Get expert's available sub-services
     * @param expertId Expert UUID
     * @returns ExpertServicesApiResponse Expert services fetched
     * @throws ApiError
     */
    public static clientBookingsControllerGetExpertServicesV1(
        expertId: string,
    ): CancelablePromise<ExpertServicesApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/bookings/expert/{expertId}/services',
            path: {
                'expertId': expertId,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get packages for an expert
     * @param expertId Expert UUID
     * @returns ExpertPackagesApiResponse Expert packages fetched
     * @throws ApiError
     */
    public static clientBookingsControllerGetExpertPackagesV1(
        expertId: string,
    ): CancelablePromise<ExpertPackagesApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/bookings/expert/{expertId}/packages',
            path: {
                'expertId': expertId,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get single-session pricing
     * @param expertId Expert UUID
     * @param sessionType Session type
     * @returns ExpertPricingApiResponse Expert pricing fetched
     * @throws ApiError
     */
    public static clientBookingsControllerGetExpertPricingV1(
        expertId: string,
        sessionType: 'single' | 'duo',
    ): CancelablePromise<ExpertPricingApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/bookings/expert/{expertId}/pricing',
            path: {
                'expertId': expertId,
            },
            query: {
                'session_type': sessionType,
            },
            errors: {
                404: `Expert or pricing not found`,
            },
        });
    }
    /**
     * Get available time slots for date range
     * @param expertId Expert UUID
     * @param startDate Range start as a full ISO-8601 UTC timestamp
     * @param endDate Range end (exclusive) as a full ISO-8601 UTC timestamp
     * @param mode Filter by mode
     * @returns ExpertAvailabilityApiResponse Expert availability fetched
     * @throws ApiError
     */
    public static clientBookingsControllerGetExpertAvailabilityV1(
        expertId: string,
        startDate: string,
        endDate: string,
        mode?: 'online' | 'client_location' | 'expert_location',
    ): CancelablePromise<ExpertAvailabilityApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/bookings/expert/{expertId}/availability',
            path: {
                'expertId': expertId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'mode': mode,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Get expert's registered locations
     * @param expertId Expert UUID
     * @returns LocationsApiResponse Expert locations fetched
     * @throws ApiError
     */
    public static clientBookingsControllerGetExpertLocationsV1(
        expertId: string,
    ): CancelablePromise<LocationsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/bookings/expert/{expertId}/locations',
            path: {
                'expertId': expertId,
            },
            errors: {
                404: `Expert not found`,
            },
        });
    }
    /**
     * Create a booking from a pending follow-up plan
     * @param requestBody
     * @returns CreateBookingApiResponse Booking created from follow-up plan
     * @throws ApiError
     */
    public static clientBookingsControllerCreateFollowupBookingV1(
        requestBody: CreateFollowupBookingDto,
    ): CancelablePromise<CreateBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/bookings/followup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Follow-up plan already booked, or (errorCode LATE_PAYMENT) retry of an expired booking whose payment went through`,
            },
        });
    }
    /**
     * Confirm payment and activate booking
     * @param bookingId Booking UUID
     * @returns ConfirmPaymentApiResponse Payment confirmed
     * @throws ApiError
     */
    public static clientBookingsControllerConfirmPaymentV1(
        bookingId: string,
    ): CancelablePromise<ConfirmPaymentApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/bookings/{bookingId}/confirm-payment',
            path: {
                'bookingId': bookingId,
            },
            errors: {
                404: `Booking not found`,
            },
        });
    }
    /**
     * Record what happened on the payment screen (app-side only)
     * @param bookingId Booking UUID
     * @param requestBody
     * @returns ReportPaymentEventApiResponse Payment event recorded
     * @throws ApiError
     */
    public static clientBookingsControllerReportPaymentEventV1(
        bookingId: string,
        requestBody: ReportPaymentEventDto,
    ): CancelablePromise<ReportPaymentEventApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/bookings/{bookingId}/payment-events',
            path: {
                'bookingId': bookingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Booking not found`,
            },
        });
    }
}
